import { MEDIA } from "@/lib/constants";

const IMGS = [
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_guincho-24h-rp/artifacts/040e7627297430ca_WhatsApp%20Image%202026-10-28%20at%2015.23.02%20%281%29.jpeg", alt: "Guincho Ventania transportando skid steer e retroescavadeira CAT em Ribeirão Preto" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_guincho-24h-rp/artifacts/e01a3e88e21fa1ca_WhatsApp%20Image%202026-10-28%20at%2015.23.03%20%281%29.jpeg", alt: "Reboque Ventania transportando picape S10 em Ribeirão Preto" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_guincho-24h-rp/artifacts/bf00723314e2ed80_WhatsApp%20Image%202026-10-28%20at%2013.51.58.jpeg", alt: "Transporte de carro em baú fechado por Auto Socorro Ventania" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_guincho-24h-rp/artifacts/52350cace9d7ef24_WhatsApp%20Image%202026-10-28%20at%2015.26.14.jpeg", alt: "Guincho Ventania removendo Mitsubishi ASX em Ribeirão Preto" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_guincho-24h-rp/artifacts/0a6701d4cb513c13_Captura%20de%20Tela%202026-10-29%20a%CC%80s%2006.29.58.png", alt: "Transporte de lancha Ventura 260 Sport pela Auto Socorro Ventania" },
  { src: "https://customer-assets-jai6qajn.emergentagent.net/job_guincho-24h-rp/artifacts/o37op4l1_WhatsApp%20Image%202026-05-22%20at%2009.52.45-2.jpeg", alt: "Guincho Ventania transportando Citroën C3 à noite em Ribeirão Preto" },
  { src: "https://customer-assets.emergentagent.com/job_guincho-24h-rp/artifacts/roifl57d_WhatsApp%20Image%202026-05-22%20at%2009.52.45.jpeg", alt: "Auto Socorro Ventania 24h atendendo na madrugada em Ribeirão Preto" },
  { src: "https://customer-assets.emergentagent.com/job_guincho-24h-rp/artifacts/o200zc3t_WhatsApp%20Image%202026-05-22%20at%2009.52.36.jpeg", alt: "Plataforma Ventania transportando Fiat Mobi em Ribeirão Preto" },
  { src: "https://customer-assets.emergentagent.com/job_guincho-24h-rp/artifacts/gkcvrexv_WhatsApp%20Image%202026-05-14%20at%2021.52.23.jpeg", alt: "Auto Socorro Ventania 24h - Atendimento noturno em Ribeirão Preto" },
  { src: "https://customer-assets.emergentagent.com/job_guincho-24h-rp/artifacts/cwvjer5l_WhatsApp%20Image%202026-05-14%20at%2021.52.53.jpeg", alt: "Guincho Ventania transportando van utilitária" },
  { src: "https://customer-assets.emergentagent.com/job_guincho-24h-rp/artifacts/hxnxw8zh_WhatsApp%20Image%202026-05-13%20at%2017.04.45.jpeg", alt: "Guincho 24h Ventania na avenida de Ribeirão Preto" },
  { src: "https://customer-assets.emergentagent.com/job_guincho-24h-rp/artifacts/pqkaubad_WhatsApp%20Image%202026-05-13%20at%2014.09.36.jpeg", alt: "Plataforma Ventania pronta para atendimento em Ribeirão Preto" },
  { src: "https://customer-assets.emergentagent.com/job_guincho-24h-rp/artifacts/njvqr9nd_WhatsApp%20Image%202026-05-13%20at%2019.01.01.jpeg", alt: "Guincho Ventania transportando furgão Fiorino em Ribeirão Preto" },
  { src: "https://customer-assets.emergentagent.com/job_guincho-24h-rp/artifacts/evm0dued_WhatsApp%20Image%202026-05-14%20at%2021.52.52.jpeg", alt: "Reboque Ventania removendo Citroën C3 em Ribeirão Preto" },
  { src: "https://customer-assets.emergentagent.com/job_guincho-24h-rp/artifacts/wgf6sv3o_WhatsApp%20Image%202026-05-14%20at%2021.52.36.jpeg", alt: "Guincho Ventania transportando picape Saveiro em Ribeirão Preto" },
  { src: MEDIA.truck2, alt: "Frota Auto Socorro Ventania atendendo em Ribeirão Preto" },
  { src: MEDIA.truck3, alt: "Guincho plataforma transportando veículo" },
  { src: MEDIA.truck4, alt: "Guincho Ventania em serviço de remoção" },
];

export const Gallery = () => {
  return (
    <section
      data-testid="gallery-section"
      className="section-pad bg-[#0a0a0a] relative"
    >
      <div className="container-custom">
        <div className="max-w-3xl mb-12">
          <span className="overline">Nossa Frota</span>
          <h2 className="mt-3 font-display uppercase font-bold text-white text-4xl md:text-5xl leading-tight tracking-tight">
            Frota Própria &{" "}
            <span className="text-[#d90429]">Sempre Pronta</span>
          </h2>
          <p className="mt-5 text-gray-400 text-lg">
            Caminhões plataforma equipados e preparados para atender qualquer
            tipo de veículo com total segurança.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {IMGS.map((img, i) => (
            <div
              key={i}
              data-testid={`gallery-img-${i}`}
              className="relative group overflow-hidden border border-[#2d3748] aspect-[4/5]"
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <span className="overline text-white">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="font-display uppercase text-white font-bold text-lg mt-1 leading-tight">
                  Ventania em Ação
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
